import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsUY: CultureInfo = {
  name: 'es-UY',
  displayName: 'Spanish (Uruguay)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-UY',
  parent: CultureInfoEs
};
